import { render, staticRenderFns } from "./wyfmx.vue?vue&type=template&id=9fdcdfda&scoped=true&"
import script from "./wyfmx.vue?vue&type=script&lang=js&"
export * from "./wyfmx.vue?vue&type=script&lang=js&"
import style0 from "./wyfmx.vue?vue&type=style&index=0&id=9fdcdfda&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fdcdfda",
  null
  
)

export default component.exports